//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 02/06/2025
// Version : 1
// Description : Pantalla principal de estadisticas de reemplazo
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import Navbar from "../../../Navbar";
import Tabla_estados_reemplazo from "./Tabla_estados_reemplazo";
import Grafico_estados_reemplazo from "./Grafico_estados_reemplazo";
import Tabla_instaladores_reemplazo from "./Tabla_instaladores_reemplazo";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function Estadisticas_reemplazo() {
  const [selectedDate, setSelectedDate] = useState(
    dayjs().subtract(1, "month").startOf("month")
  );

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={2}
        color="white"
        textAlign="center"
        marginTop={1}
      >
        <Typography variant="h4">
          Panel de estadísticas de reemplazo
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            views={["year"]}
            //label="Año"
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  marginTop: 2,
                  width: "200px",
                  backgroundColor: "white", // Fondo blanco
                  "& .MuiInputBase-input": {
                    backgroundColor: "white", // Asegura que el input también sea blanco
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>
      <Grid container spacing={2} padding={2} justifyContent={"center"}>
        <Grid
          container
          spacing={2}
          padding={1}
          justifyContent={"left"}
          marginTop={1}
        >
          <Grid item xs={12} sm={12}>
            <Tabla_estados_reemplazo selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Grafico_estados_reemplazo selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_instaladores_reemplazo selectedDate={selectedDate} />
          </Grid>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
    </div>
  );
}

export default Estadisticas_reemplazo;
